export default [
    "24 24",
    '<path d="M3 15H21M3 9H21" stroke="var(--ci-primary-color, currentColor)"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

